import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Cliente, ClienteRequest } from "@/shared/types/cliente";

export async function editCliente(id: string, isFe: boolean, request: ClienteRequest): Promise<Cliente> {
    await sleep(1000);
    const response = await api.put("clientes/" + (isFe ? "fe/" : "") + id, request);
    return response.data;
}

export function useEditClienteMutation(id: string, isFe: boolean, mutationConfig: MutationConfig<Cliente, ClienteRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: ClienteRequest) => await editCliente(id, isFe, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["clientes"] });
        },
    })
}

export interface EditClienteMutationProps {
    id: string,
    isFe?: boolean,
    mutationConfig?: MutationConfig<Cliente, ClienteRequest>,
    children?: (mutationResult: MutationResult<Cliente, ClienteRequest>) => ReactNode
}

export function EditClienteMutation({
    id,
    isFe = false,
    children,
    mutationConfig
}: EditClienteMutationProps) {
    const mutationResult = useEditClienteMutation(id, isFe, mutationConfig);
    return children && children(mutationResult)
}